export default function getSpotinaryUrl(imageId, options) {
  let url = 'https://image-provider.staging-spot.im/';

  url += imageId;

  if (options.width) {
    url += `/${options.width}x${options.height}`;

    if (options.crop === 'thumb') {
      url += ',fit';
    }
  }

  return url;
}
